module.exports = __webpack_public_path__ + "media/images/icon/ico_silver-ecc8aa39cac10fdc2b31db9beee5a444.svg";